export const toDateKey = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const shiftDateKey = (dateKey, days) => {
  const [year, month, day] = String(dateKey).split("-").map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  return toDateKey(date);
};

export const enumerateDateKeys = (startDate, endDate) => {
  if (!startDate || !endDate || startDate > endDate) return [];
  const dates = [];
  for (let cursor = startDate; cursor <= endDate; cursor = shiftDateKey(cursor, 1)) {
    dates.push(cursor);
  }
  return dates;
};

export const sumBy = (rows, selector) =>
  (Array.isArray(rows) ? rows : []).reduce(
    (total, row) => total + Number(selector(row) || 0),
    0
  );

export const safePercentage = (actual, target) => {
  const numericTarget = Number(target || 0);
  if (numericTarget <= 0) return null;
  return Math.round((Number(actual || 0) / numericTarget) * 100);
};

export const formatBonpasStoreLabel = (storeName) => {
  const normalized = String(storeName || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/Đ/g, "D")
    .replace(/đ/g, "d")
    .toUpperCase()
    .replace(/\bBONPAS\b/g, " ")
    .replace(/[^A-Z0-9]+/g, " ")
    .trim();
  if (!normalized) return "BP";

  const fixedLabels = {
    "143 DIEN BIEN PHU": "BP 143DBP",
    "143 DBP": "BP 143DBP",
  };
  if (fixedLabels[normalized]) return fixedLabels[normalized];

  const tokens = normalized.split(/\s+/);
  const numberIndex = tokens.findIndex((token) => /\d/.test(token));
  const storeNumber = numberIndex >= 0 ? tokens[numberIndex] : "";
  const addressTokens = tokens.slice(numberIndex >= 0 ? numberIndex + 1 : 0);
  const addressCode = addressTokens
    .filter((token) => !/^\d+$/.test(token))
    .map((token) => token[0])
    .join("");

  return ["BP", `${storeNumber}${addressCode}`].filter(Boolean).join(" ");
};

export const aggregateKpiRows = (rows, selectedDate) => {
  const validRows = Array.isArray(rows) ? rows : [];
  const seasonTarget = sumBy(validRows, (row) => row.KPIBanKemLon);
  const dailyTarget = sumBy(validRows, (row) => {
    const day = (row.NgayTargets || []).find(
      (item) => item.Ngay === selectedDate
    );
    return day?.KPIBanKemLon;
  });
  const productionSeasonTarget = sumBy(
    validRows,
    (row) => row.KPISanXuatKemLon
  );
  const productionDailyTarget = sumBy(validRows, (row) => {
    const day = (row.NgayTargets || []).find(
      (item) => item.Ngay === selectedDate
    );
    return day?.KPISanXuatKemLon;
  });
  const starts = validRows.map((row) => row.NgayBatDau).filter(Boolean).sort();
  const ends = validRows.map((row) => row.NgayKetThuc).filter(Boolean).sort();

  return {
    hasKpi: seasonTarget > 0 || dailyTarget > 0,
    hasProductionKpi:
      productionSeasonTarget > 0 || productionDailyTarget > 0,
    seasonTarget: seasonTarget || null,
    dailyTarget: dailyTarget || null,
    productionSeasonTarget: productionSeasonTarget || null,
    productionDailyTarget: productionDailyTarget || null,
    startDate: starts[0] || null,
    endDate: ends[ends.length - 1] || null,
    seasonNames: [...new Set(validRows.map((row) => row.TenMuaVu).filter(Boolean))],
  };
};

export const filterInventoryByStores = (inventory, storeIds) => {
  const allowed = new Set((storeIds || []).map(Number));
  const stores = (inventory?.NhomBravo || [])
    .flatMap((group) => group.CuaHang || [])
    .filter((store) => allowed.has(Number(store.MaCH)));

  return {
    totalLargeCakes: sumBy(stores, (store) => store.ChiTiet?.BanhKemLon),
    stores,
  };
};
